(() => {
  const root = document.documentElement;
  const storageKey = 'aurymed-theme';

  const current = () => root.dataset.aurymedTheme === 'light' ? 'light' : 'dark';

  const syncButtons = () => {
    const isLight = current() === 'light';
    document.querySelectorAll('[data-aury-theme-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', isLight ? 'true' : 'false');
      button.setAttribute('aria-label', isLight ? 'Dunkles Design aktivieren' : 'Helles Design aktivieren');
      button.title = isLight ? 'Dunkles Design aktivieren' : 'Helles Design aktivieren';
    });
  };

  const setTheme = (theme) => {
    root.dataset.aurymedTheme = theme;
    try { localStorage.setItem(storageKey, theme); } catch (e) {}
    syncButtons();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-aury-theme-toggle]');
    if (!button) return;
    setTheme(current() === 'light' ? 'dark' : 'light');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtons, { once: true });
  } else {
    syncButtons();
  }
})();
